module.exports = __webpack_public_path__ + "img/girls_studying.edd8d497.jpg";